<template>
  <div class="deposit-promo">
    <div class="deposit-promo__wrapper">
      <div
        class="form-input"
        :class="[
          { 'form-input--full': form.promo_code },
          { 'form-input--error': errors.promo_code },
        ]"
      >
        <input v-model="form.promo_code" @blur="handleBlur" />
        <span class="form-input__label">{{ $t('prepaid.promo_code') }}</span>
        <img
          v-if="promosSuccess"
          class="deposit-promo__success-icon"
          src="@/assets/icons/icon-check.svg"
          alt="Icon success"
        />
        <div v-if="errors.promo_code" class="form-input__error" v-text="errors.promo_code" />
      </div>
      <div class="deposit-promo__button-wrapper">
        <ButtonElement
          v-if="!promosSuccess"
          :text="$t('button_props.submit')"
          :disabled="buttonDisabled || !form.promo_code || !!errors.promo_code"
          @click-button="handleSubmit"
        />
        <div v-if="promosSuccess" class="deposit-promo__submitted">
          {{ $t('prepaid.promo_applied') }}
        </div>
      </div>
    </div>
    <div v-if="promosSuccess && promo" class="deposit-promo__success">
      <p class="deposit-promo__trial">
        {{ $t('promo.expiration_date') }} {{ formatDate(promo.expired_at) }}
      </p>
      {{ promo.description }}
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';
import { validatePromoCode } from '@/utils/forms/promoValidation';

export default {
  name: 'DepositPromoCode',
  components: {
    ButtonElement,
  },
  props: {
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        promo_code: '',
      },
      errors: {
        promo_code: '',
      },
      promosSuccess: false,
      promo: null,
    };
  },
  watch: {
    'form.promo_code'() {
      this.checkPromo();
    },
  },
  methods: {
    checkPromo() {
      const validation = validatePromoCode(this.form.promo_code);

      if (!validation.isValid) {
        this.errors.promo_code = this.$t(`prepaid.${validation.error}`);
      } else {
        this.errors.promo_code = '';
      }
    },
    handleBlur() {
      this.checkPromo();
    },
    handleSubmit() {
      if (this.errors.promo_code || !this.form.promo_code) {
        return;
      }

      this.$emit('apply-promo', this.form.promo_code);
    },
    handleSuccess(promoData) {
      this.promo = {
        description: promoData.description,
        expired_at: promoData.expired_at,
      };
      this.promosSuccess = true;
    },
    handleError(errorMessage) {
      this.errors.promo_code = errorMessage;
      this.promosSuccess = false;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${day}.${month}.${year}`;
    },
    reset() {
      this.form.promo_code = '';
      this.errors.promo_code = '';
      this.promosSuccess = false;
      this.promo = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.deposit-promo {
  padding: 0 7rem 6rem 6rem;
  min-width: 50rem;
  width: 60%;

  &__wrapper {
    display: flex;
    justify-content: space-between;
    gap: 1.2rem;
    width: 100%;

    .form-input input {
      border-radius: 6px;
    }
  }

  &__success-icon {
    max-width: 21px;
    max-height: 21px;
    position: absolute;
    z-index: 0;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  &__button-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    max-width: 50%;
    width: 100%;
    height: 5rem;

    .deposit-promo__submitted {
      color: #219653;
      font-size: 1.4rem;
      font-family: Roboto;
      font-weight: 400;
    }

    .button {
      border-radius: 6px;
      height: 100%;
      width: 100%;
    }
  }

  &__success {
    font-weight: 400;
    font-size: 1.4rem;
    color: #7f858d;
    line-height: 16.41px;

    .deposit-promo__trial {
      color: #bfc2c6;
      font-weight: 400;
      font-size: 1.4rem;
      margin: 0.8rem 0 2.3rem 0;
    }
  }

  .form-input {
    max-width: 50%;
    width: 100%;
    margin-bottom: 0;
  }
}

@include below(993px) {
  .deposit-promo {
    padding: 15px;
  }
}

@include below(769px) {
  .deposit-promo {
    padding: 0 3rem 6rem;
  }
}

@include below(500px) {
  .deposit-promo {
    min-width: 40rem;
    width: 70%;
  }
}
</style>
